<template>
  <div class="my-1">
    <label class="lead mb-1">{{ action.node_data.title || "Categoría de alarma" }}</label>
    <b-form-input
      v-if="showAppliedMessage"
      :value="appliedMessage"
      data-cy="applied-alarm-category-message"
      readonly
    />
    <v-select
      v-else
      v-model="selectedCommentId"
      :options="options"
      :loading="loading"
      :reduce="item => item.value"
      :disabled="isApplied || terminated || validating"
      :clearable="!isApplied"
    />
    <div v-if="!showAppliedMessage" class="my-2">
      <b-button variant="primary" size="sm" :disabled="isApplyDisabled" @click="applyCategory">
        <feather-icon icon="CheckIcon" size="18" />
        Aplicar
      </b-button>
    </div>
    <div class="text-right my-1">
      <b-button
        variant="primary"
        size="sm"
        :disabled="!isApplied || terminated || validating || action.data.continue"
        @click="$emit('continue', action)"
      >
        {{ $t("action_plan.viewer.continue") }}
        <feather-icon icon="ChevronRightIcon" size="18" />
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import vSelect from "vue-select";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "AlarmCategory",
  components: { vSelect },
  props: {
    action: Object,
    alarmId: [Number, String],
    alarmTypeId: [Number, String],
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  data() {
    return { loading: false, applying: false, selectedCommentId: null };
  },
  computed: {
    options() {
      if (!this.alarmTypeId) return [];

      return store.getters["alarm_comment/getItems"].map(item => ({
        value: item.id,
        label: item.comment,
      }));
    },
    isApplied() {
      return this.action?.data?.category_applied === true;
    },
    appliedMessage() {
      return String(this.action?.data?.alarm_category_message || "").trim();
    },
    showAppliedMessage() {
      return Boolean(this.appliedMessage)
        && (this.isApplied || this.action?.data?.continue || this.terminated);
    },
    isApplyDisabled() {
      return this.terminated || this.validating || this.applying || this.isApplied
        || !this.alarmId || !this.alarmTypeId || !this.selectedCommentId;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      if (this.alarmTypeId && !this.showAppliedMessage) {
        await store.dispatch("alarm_comment/getAll", {
          "id_type_alarm[]": this.alarmTypeId,
        });
      }
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async applyCategory() {
      if (!this.selectedCommentId || !this.alarmId) return;

      this.applying = true;
      try {
        let message = this.options.find(item => item.value === this.selectedCommentId)?.label;
        if (!this.preview) {
          const response = await axios.post("/v1/action_plan/update-alarm-category", {
            id_alarm: this.alarmId,
            id_alarm_comment: this.selectedCommentId,
          });
          message = response.data?.data?.alarm_category_message;
        }
        if (!message) return;
        this.$set(this.action.data, "alarm_category_message", message);
        this.$set(this.action.data, "category_applied", true);
        this.$set(this.action.data, "status", "OK");
        this.$emit("checkpoint");
      } catch (error) {
        this.$set(this.action.data, "status", "ERROR");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.response?.data?.message || this.$t("errors.generic"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.applying = false;
      }
    },
  },
};
</script>
